import styled from "styled-components";
import TourGroupItem from "./TourGroupItem";

//-------------------------------------------------------------------

const ListContainer = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding-right: 5px;
`;

//------------------------------------------------------

const TourGroupList = ({
  tourGroupIds,
}: {
  tourGroupIds: string[] | undefined;
}) => {
  if (!tourGroupIds || tourGroupIds?.length === 0) {
    return (
      <div>
        <div>No tour groups found</div>
        <div style={{ fontSize: "12px", marginTop: "8px" }}>
          There are no tour groups scheduled for this day
        </div>
      </div>
    );
  }

  return (
    <ListContainer>
      {tourGroupIds?.map((tourGroupId) => (
        <TourGroupItem key={tourGroupId} tourGroupId={tourGroupId} />
      ))}
    </ListContainer>
  );
};

export default TourGroupList;
